import { FC } from "react";
import { Text } from "@/components/atoms/Text";
import AccountFilled from "@/icons/__generated__/AccountFilled/AccountFilled16";
import { Stars } from "./Stars";

interface Listing {
  space_review_stars?: number;
  space_review_count?: number;
  number_guests?: number;
}

interface StarsAndGuestsProps {
  listing: Listing;
}

export const StarsAndGuests: FC<StarsAndGuestsProps> = ({ listing }) => {
  return (
    <div className="tw-flex">
      {(listing.space_review_stars ?? 0) > 0 &&
        (listing.space_review_count ?? 0) > 0 && (
          <div className="tw-flex tw-items-center tw-leading-16 tw-mr-16">
            <Stars
              reviewStars={listing.space_review_stars ?? 0}
              reviewCount={listing.space_review_count ?? 0}
            />
          </div>
        )}
      {listing.number_guests && (
        <div className="tw-flex tw-items-center tw-leading-16 tw-text-gray-900">
          <span className="tw--mt-4">
            <AccountFilled />
          </span>
          <Text typeface="body-2" className="tw-ml-6">
            {listing.number_guests}
          </Text>
        </div>
      )}
    </div>
  );
};

export default StarsAndGuests;
